import { useReducer } from 'react';

import { CreateSpaceActionType, ReducerModalState } from '../types/SpaceTypes';

const createSpaceReducer = (
  state: ReducerModalState,
  action: CreateSpaceActionType,
): ReducerModalState => {
  const initialState: ReducerModalState = {
    isShowModal: { selectTemplate: false, createSpace: false },
    mapTemplate: {},
    templateType: 'templates',
  };

  switch (action.type) {
    case 'SHOW_MAP_TEMPLATE_MODAL': {
      return {
        isShowModal: { selectTemplate: true, createSpace: false },
        mapTemplate: {},
        templateType: 'templates',
      };
    }
    case 'ON_SELECT_MAP_TEMPLATE': {
      return {
        isShowModal: { selectTemplate: false, createSpace: true },
        mapTemplate: action.template,
        templateType: action.templateType,
      };
    }
    case 'ON_SELECT_EMPTY_MAP_TEMPLATE': {
      return {
        isShowModal: { selectTemplate: false, createSpace: true },
        mapTemplate: {
          hashId: action.templateHashId,
          name: '빈 맵',
          categories: [8],
        },
        templateType: 'templates',
      };
    }
    case 'HIDE_MAP_TEMPLATE_MODAL':
    case 'HIDE_CREATE_SPACE_MODAL':
    default:
      return initialState;
  }
};

export const useCreateSpaceReducer = (initializer: ReducerModalState) =>
  useReducer(createSpaceReducer, initializer);
